import React from 'react';
import Container from './Container';
import { Grommet } from "grommet";

const appdetails = {
  clientId: "720f8c6b-406e-473c-8f48-103c54ccbbc1",
  authorityHost: "https://login.microsoftonline.com",
  tenantId: "c5f9cef3-6300-4cc2-90f6-be1b3f6e31d8"
};

function App(props) {
  return (
    <div className='App'>
      <Grommet
        theme={{ global: { colors: { brand: '#369C81' } }, formField: { border: { color: "transparent" } } }}
      >
        <header className='App-header'>
        </header>
        <Container appdetails={appdetails}>{props.children}</Container>
      </Grommet>
    </div>
  );
}

export default App;
